import { useLayoutEffect } from 'react';
import { History } from 'history';

export const useActiveLinks = (history: History, setActive: Function, targets: Array<string>, setIsExpanded?: Function) => {
  // this only runs on mount and unmount as described in https://daveceddia.com/useeffect-hook-examples/ and https://github.com/ReactTraining/history#listening
  // we are doing this because our header currently sits outside the Switch component
  // so it's children are not re-rendered whenever the route changes 
  useLayoutEffect(() => {
    targets.forEach(target => {
      if (history.location.pathname.indexOf(target) >= 0) {
        if (typeof setIsExpanded === "function") {
          setIsExpanded(true);
        }
        setActive(true)
      }
    });

    const target: string = targets[0];

    const unlisten = history.listen((location: any) => {
      setActive(location.pathname.indexOf(target) >= 0)
    })

    return () => unlisten();
  }, []);

}